// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2W3X3","sendOtp":"AuthorizeToLogin_sendOtp__3_Hgf"};